
import QuoteUpCircle from "../../../assets/filled/QuoteUpCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function QuoteUpCircleIcon({ className, dataTestid = "QuoteUpCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <QuoteUpCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
